import { ExperienceData } from './types'

export const experienceData: ExperienceData[] = [
    {
        title: 'Website Content Coordinatorship',
        company: 'Altinbas University',
        location: 'Istanbul, Türkiye',
        dates: 'Oct 2023 - Sep 2024',
        description: '',
        logoSrc: 'https://satinalma.altinbas.edu.tr/wp-content/uploads/2018/05/logo-altinbas-e1526024464154.png'
    },
    {
        title: 'UNICEF Face-to-Face Program',
        company: 'UNICEF',
        location: 'Istanbul, Türkiye',
        dates: 'Nov 2022 - Dec 2022',
        description: '',
        logoSrc: 'https://logowik.com/content/uploads/images/930_unicef.jpg'
    }
]
